<template>
	<div id="content" class="content payment">
		<template v-if="resultCode!=='0000'">
			<div class="container">
				<div class="page-title">
					<h2 class="tit">결제실패</h2>
				</div>
				<div class="payment-done">
					<strong>결제가 실패되었습니다.</strong>
					<p class="no">에러코드 : {{resultCode}}</p>
					<p class="guide">{{resultCode==='01'?'다시 시도해주세요':resultMsg}}</p>
				</div>
			</div>
			<div class="btn-area">
				<button type="button" class="btn-submit" @click="orderDone">목록가기</button>
			</div>
		</template>
		<template v-else>
			<div class="container">
				<!-- 페이지 타이틀 -->
				<div class="page-title">
					<h2 class="tit">결제 완료</h2>
				</div>
				<div class="payment-done">
					<strong>결제가 완료 되었습니다.</strong>
					<p class="no">주문번호 : {{orderInfo.oid}}</p>
					<p class="guide">결제 내역 확인은 <span>마이페이지의 나의구매</span>에서 확인하실 수 있습니다.</p>
				</div>

				<order-product :produc-list="producList" :oid="oid"></order-product>

				<div class="payment-info">
					<h3 class="title">결제 정보</h3>
					<div class="gui-tbl">
						<div class="row-box">
							<div class="th">총 결제 금액</div>
							<div class="td">{{ orderInfo.orderPrice | currency }} 원</div>
						</div>
						<div class="row-box">
							<div class="th">결제방법</div>
							<div class="td">{{paidType}}</div>
						</div>
						<!-- TODO 가상계좌, 입금기한 저장 후 가져오기 -->
						<template v-if="orderInfo.paidType==='D'">
							<div class="row-box">
								<div class="th">입금계좌</div>
								<div class="td"><span>농협/123456789123456</span></div>
							</div>
							<div class="row-box">
								<div class="th">예금주</div>
								<div class="td">상상진화</div>
							</div>
							<div class="row-box">
								<div class="th">입금기한</div>
								<div class="td">2021.08.31</div>
							</div>
						</template>
					</div>
				</div>
				<div class="btn-area">
					<button type="button" class="btn-submit" @click="orderDone">결제완료</button>
				</div>
			</div>
		</template>

	</div>
</template>

<script>
import OrderProduct from "@/components/shop/order/orderProduct"
export default {
	name: "orderDone",
	components: {OrderProduct},
	data() {


		// alert('oid :' + this.$route.query.oid)
		// alert('url :' + window.document.URL)

		return {
			orderInfo: new this.OrderInfoVO( this.getSessionProc() ),
			oid: this.$route.query.oid,
			producList: [],
			paidType: "신용카드",
			resultCode: this.$route.query.resultCode,
			resultMsg: this.$route.query.resultMsg,
		}
	},
	created() {
		this.getOrderInfo()
	},
	methods: {
		getOrderInfo(){
			console.log("data", this.orderInfo)
			this.axiosCaller.get(this, this.APIs.SHOP_ORDER + "/getOrderInfo", {
				oid :this.oid
			}, (res) => {
				if (res.data.status === "ok") {
					this.orderInfo = res.data.orderInfo;
					this.producList = res.data.orderGoods;
					this.paidType = res.data.orderInfo.paidType;

					switch (this.paidType) {
						case 'B':
							return this.paidType = '계좌이체'
						case 'C':
							return this.paidType = '신용카드'
						case 'D':
							return this.paidType = '무통장입금'
						case 'K':
							return this.paidType = '카카오페이'
						case 'N':
							return this.paidType = '네이버페이'
						default:
							return this.paidType = '신용카드'   //기본으로 설정되어 있음
					}
				} else {
					console.log(this.$route.query.oid)
					this.swalUtils.gritter("Error", res.msg, "error")
							.then(() => {
								location.href = document.referrer
							})
				}
			});
		},

		orderDone() {
			location.href = "/app/shop/goods"
		},
	}
}
</script>

<style scoped>

</style>
